module.exports = __webpack_public_path__ + "images/category_lp/common/large-arrow_6039f163b2f18b4c0a6d89c813855567.png";